import styled from 'styled-components';
import { Modal } from 'antd';
import { color } from 'asserts/styles/colors';
import DefaultButton from 'components/button/DefaultButton';

interface ModalProps {
  isModalOpen: boolean;
  leftBtnName?: string;
  rightBtnName?: string;
  powerOK?: boolean;
  children?: Exclude<React.ReactNode, 'string'>;
  onClickLeftBtn?: (() => void) | null;
  onClickRightBtn?: (() => void) | null;
  onCloseModal: (() => void) | null;
}

const BaseModal = ({
  isModalOpen,
  rightBtnName,
  leftBtnName,
  powerOK,
  children,
  onClickLeftBtn,
  onClickRightBtn,
  onCloseModal
}: ModalProps) => {
  return (
    <>
      <Modal
        open={isModalOpen}
        title="알림"
        footer={null}
        centered
        closeIcon={!powerOK}
        keyboard={!powerOK}
        maskClosable={!powerOK}
        onCancel={() => onCloseModal && onCloseModal()}
        zIndex={3000}
      >
        <InnerWrapper>
          <Contents>{children}</Contents>
          <ButtonWrapper>
            {leftBtnName && (
              <DefaultButton
                text={leftBtnName}
                type="text"
                onClick={() => {
                  onClickLeftBtn && onClickLeftBtn();
                }}
              />
            )}

            {rightBtnName && (
              <DefaultButton
                text={rightBtnName}
                type="text"
                onClick={() => {
                  onClickRightBtn && onClickRightBtn();
                }}
              />
            )}
          </ButtonWrapper>
        </InnerWrapper>
      </Modal>
    </>
  );
};

export default BaseModal;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 32px;
`;

const Contents = styled.div`
  color: ${color.black2};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;

  button {
    color: ${color.black2};
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  & p:first-of-type button {
    color: ${color.gray500};
  }
`;
